export async function saveEntry(data, empty) {
  console.log(data);
}
